<div id="sidebar">
  <mat-nav-list>

    <!--Module level-->
    <a mat-list-item
       [routerLinkActive]="'active'"
       [routerLink]="['/demo/module-level']">
      <mat-icon class="sidenav-icon">dashboard</mat-icon>
      {{ 'Module level' | translate }}
    </a>

    <!--Component level-->
    <a mat-list-item
       [routerLinkActive]="'active'"
       [routerLink]="['/demo/component-level']">
      <mat-icon class="sidenav-icon">bar_chart</mat-icon>
      {{ 'Component level' | translate }}
    </a>

    <!--Delete message-->
    <a mat-list-item
       [routerLinkActive]="'active'"
       [routerLink]="['/demo/delete-message']">
      <mat-icon class="sidenav-icon">bar_chart</mat-icon>
      {{ 'Delete message' | translate }}
    </a>

    <!--Rpc message-->
    <a mat-list-item
       [routerLinkActive]="'active'"
       [routerLink]="['/demo/rpc-demo']">
      <mat-icon class="sidenav-icon">leak_add</mat-icon>
      {{ 'Rpc demo' | translate }}
    </a>

    <!--Historical message-->
    <a mat-list-item
       [routerLinkActive]="'active'"
       [routerLink]="['/demo/historical-message']">
      <mat-icon class="sidenav-icon">question_answer</mat-icon>
      {{ 'Historical message' | translate }}
    </a>

  </mat-nav-list>
</div>
